import { useState, useEffect, useRef, useContext } from 'react';
import ReactSelect from 'react-select';
import { Slider, LinearProgress, TextField, Radio, RadioGroup, FormControlLabel, Checkbox, MenuItem, Select, TextareaAutosize } from '@mui/material';
import { CheckCircleRounded, ExpandMore } from '@mui/icons-material';
import CircleIcon from '@mui/icons-material/Circle';
import useWindowDimensions from '../../Hooks/useWindowDimensions';
import AssessmentQuestionContext from '../../Store/AssessmentQuestionContext';
import unchecked from '../../Assets/Images/Unchecked.svg'
import { useSearchParams } from 'react-router-dom';

const Question = props => {

  // console.log("Question props", props);
  // console.log("Question", props?.question?.question);

  const assessCtx = useContext(AssessmentQuestionContext);
  const { windowWidth } = useWindowDimensions();
  const [showSlider, setShowSlider] = useState(false);
  const [progress, setProgress] = useState(props?.currentValue);
  const [sliderWidth, setSliderWidth] = useState(90);
  const [maxWidth, setMaxWidth] = useState(props.question?.answers?.length);
  const [runTimeoutFunc, setRunTimeoutFunc] = useState(false);
  const [month, setMonth] = useState("")
  const [year, setYear] = useState("")
  const [textAns, setTextAns] = useState(props.question?.answerTxt);
  const [selectedAnswers, setSelectedAnswers] = useState();
  const [notApplicable, setNotApplicable] = useState(false);
  const [selectionColor, setSelectionColor] = useState('')
  const [hasLeader, setHasLeader] = useState(false);
  const [name, setName] = useState('');
  const [searchParams, setSearchParams] = useSearchParams();
  const isSelected = (ans) => selectedAnswers.includes(ans);
  const months = [
    { name: "January", number: "01" },
    { name: "February", number: "02" },
    { name: "March", number: "03" },
    { name: "April", number: "04" },
    { name: "May", number: "05" },
    { name: "June", number: "06" },
    { name: "July", number: "07" },
    { name: "August", number: "08" },
    { name: "September", number: "09" },
    { name: "October", number: "10" },
    { name: "November", number: "11" },
    { name: "December", number: "12" }
  ];


  const isHideInitials = process.env.REACT_APP_IS_HIDE_INITIALS == 'true';

  // console.log("assessCtx.questions", assessCtx.questions);

  const years = Array.from({ length: 2024 - 1995 + 1 }, (_, index) => ({
    year: 1995 + index
  }));

  useEffect(() => {
    if (props.question?.answerType === "slider") {
      if ((props.question?.answer == 0 || !props.question?.answer) && !progress) {
        setShowSlider(false);
      } else if (props.question?.answer > 0 || progress > 0) {
        setShowSlider(true);
      }
    }
    if (props.question?.answerType == "multiple_choice") {
      // console.log(props.question?.answer)
      let selAnswer = props.question?.answers?.find(obj => obj.value == props.question?.answer);
      // console.log(selAnswer);
      if (selAnswer) {
        setSelectedAnswers(selAnswer.desktopText);
      }
    } else {
      if (!props.question?.answerTxt || props.question?.answerTxt == "") {
        setTextAns("");
      } else {
        setTextAns(props.question?.answerTxt);
      }
    }

  }, [props.question?.answer, progress, props.question?.answerType, props.question?.answers, props.question?.answerTxt])

  // empty text area on question change
  useEffect(() => {
    if (!props.question?.answerTxt || props.question?.answerTxt == "") {
      setTextAns("");
    } else {
      setTextAns(props.question?.answerTxt);
    }

    giveHeaderColor(props?.question)
  }, [props.question]);

  // useEffect(() => {
  //   if(runTimeoutFunc) { 
  //     const timer = setTimeout(() => {
  //       if(props.question?.answer == 0 || !props.question.answer) {
  //         setShowSlider(false);
  //       }
  //     }, 500);
  //     return () => {
  //       setRunTimeoutFunc(false);
  //       clearTimeout(timer);
  //     }
  //   }

  // }, [props.question?.answer, runTimeoutFunc]);

  // console.log("showSlider", showSlider);



  useEffect(() => {
    if (props.question?.answer == 0 || !props.question?.answer) setProgress(0);
    // setProgress(props.question.answer);
    else if (props.question?.answer > 0) {
      const findAnsOption = props.question?.answers?.find((ans) => ans?.value === props?.question?.answer);
      setProgress(findAnsOption?.orderNo);
    }
  }, [props.question]);

  useEffect(() => {
    switch (props.question?.answers?.length) {
      case 2: setSliderWidth(36); break;
      case 3: setSliderWidth(56); break;
      case 4: setSliderWidth(76); break;
      case 5: setSliderWidth(85); break;
      case 6: setSliderWidth(90); break;
      default: break;
    }

    setMaxWidth(props.question?.answers?.length);


  }, [props, props.question?.question, props.question?.answer])

  // console.log("props.question.answer", props.question.answer);
  // console.log("progress", progress); // console.log("showSlider", showSlider);

  // useEffect(() => {
  //   const timer = () => setTimeout(() => {
  //     if(selectedAnswers.length > 0){
  //       props.questionAnswered(selectedAnswers);
  //       setSelectedAnswers([]);
  //     }
  //   }, 2000);
  //   clearTimeout(timer());
  //   if(selectedAnswers && selectedAnswers.length > 0){
  //     timer();
  //   }
  // }, [selectedAnswers])


  const getLeft = (index) => {
    switch (props.question?.answers?.length) {
      case 2: return index * 80;
      case 3: return index * 40;
      case 4: return index * 27;
      case 5: return index * 20;
      case 6: return index * 16;
      case 7: return index * 16.6;
      default: return index * 20;
    }
  }

  const getLeftRadio = (index) => {
    switch (props.question?.answers?.length) {
      case 2: return index * 80;
      case 3: return index * 40;
      case 4: return index * 27;
      case 5: return index * 6;
      case 6: return index * 4;
      default: return index * 20;
    }
  }

  const getRadioWidth = (answers) => {

    switch (answers) {
      // case 3: return {width: "70%", marginLeft: "7.5%"};
      case 3: return { width: windowWidth > 1000 ? "75%" : windowWidth > 900 ? "75%" : windowWidth < 651 && windowWidth > 550 ? "90%" : windowWidth < 551 ? "95%" : "90%" };
      // case 4: return { width: "75%", margin: "0 auto" };

      case 4: return { width: windowWidth < 551 ? "95%" : windowWidth < 651 ? "90%" : windowWidth < 831 ? "80%" : "45ch", margin: "0 auto" };
      case 5: return { width: "90%", marginLeft: "2.5%" };
      case 6: return { width: "100%", marginLeft: "0%" };
      default: return { width: "50%" };
    }
    // if(answers === 3) { return {width: "70%", marginLeft: "7.5%"}; }
    // return {width: "50%"};
  }

  const radioOptionWidth = (answers) => {
    switch (answers) {
      case 3: return "90%";
      // case 4: return "90%";
      case 4: return "100%";
      case 5: return "20%";
      case 6: return "16%";
      default: return "20%";
    }
  }

  // console.log("progress", progress);
  const updateStep = (ansVal, orderNo) => {
    // console.log("\n\n\nansVal", ansVal);
    // console.log("orderNo", orderNo, "\n\n\n");
    setShowSlider(true);
    // setTimeout(() => {setProgress(progressArg)}, 0);
    // props.questionAnswered(progressArg);
    setTimeout(() => { setProgress(orderNo) }, 0);
    // setTimeout(() => {setProgress(ansVal)}, 0);
    props.questionAnswered(ansVal);
    // setRunTimeoutFunc(true);
  }

  const updateDropDownStep = (ansVal, orderNo) => {
    // console.log(ansVal);
    // console.log(orderNo);
    // console.log(props);
    props.questionAnswered(ansVal);
    setTimeout(() => { setProgress(orderNo) }, 0);
  }

  const updateRadioStep = (ansVal, orderNo) => {

    setTimeout(() => { setProgress(orderNo) }, 0);
    props.questionAnswered(ansVal);
    setTimeout(() => {
      // setProgress(0);
    }, 500);

  }

  const getLabelStyle = () => {

    // console.log("props.question", props.question);
    if (window.innerWidth > 650) {

      if (props.question?.answers?.length === 5) {
        // return { width: "100%", marginLeft: "-50%" };
        return { width: "14ch", marginLeft: "-7ch" };
      } else if (props.question?.answers?.length === 4) {
        return { width: "95%" };
      } else if (props.question?.answers?.length === 3 && props.question?.answerType === "radio") {
        // return { width: "200%", marginLeft: "-100%" };
        // return { width: "25ch" };
      } else if (props.question?.answers?.length === 2) {
        return { width: "400%", marginLeft: "-200%" };
      } else {
        return { width: "150%", marginLeft: "-75%" };
      }
      // return { width: "14ch", marginLeft: "-7ch" };

    } else {

      if (props.question?.answers?.length === 6) {
        return { width: "14ch", marginLeft: "-7ch", wordBreak: "break-all" };
      }
      // if(props.question?.answers?.length === 5) {
      //   return { width: "120%", marginLeft: "-60%" };
      // } else if(props.question?.answers?.length === 4) {
      //   return { width: "150%", marginLeft: "-75%" };
      // } else if(props.question?.answers?.length === 3) {
      //   return { width: "300%", marginLeft: "-150%" };
      // } else if(props.question?.answers?.length === 2) {
      //   return { width: "500%", marginLeft: "-250%" };
      // } else {
      //   return { width: "150%", marginLeft: "-75%" };
      // }
      // else return { width: "12ch", marginLeft: "-6ch" };
      else if (props?.question?.answerType === "slider") {
        // return { width: "9ch", marginLeft: "-4.5ch" };
        // return { width: "7ch", marginLeft: "-3.5ch" };
        return { width: "10ch", marginLeft: "-5ch" };
      } else return { width: "auto" };
    }

  }

  const checkOpacity = (index) => {
    if (index === 0 && showSlider) return "0";
    else return "1";
  }

  const checkSelected = (optionOrderNo) => {
    // const checkSelected = (data, value) => {
    // console.log("checkSelected data:", data, "value:", value);
    // if(progress === value) {
    if (progress && (Number(progress) === Number(optionOrderNo))) {
      // console.log("desktopText", data.desktopText);
      return "label active";
    }
    else return "label";
  }
  const checkSelectedlabel = (optionOrderNo) => {
    // const checkSelected = (data, value) => {
    // console.log("checkSelected data:", data, "value:", value);
    // if(progress === value) {
    if (progress && (Number(progress) === Number(optionOrderNo))) {
      // console.log("desktopText", data.desktopText);
      return "desktop-labels activelabel";
    }
    else return "desktop-labels";
  }

  const updateSliderTextHighlight = (progress) => {
    // console.log("progress", progress);
    // console.log("desktopText", props?.question?.answers?.find(ans => ans.value === progress)?.desktopText);
    let activeSlider = null;
    // let sliderText = props?.question?.answers?.find(ans => ans.value === progress)?.desktopText;
    let sliderText = props?.question?.answers?.find(ans => ans.value === progress)?.desktopText;
    switch (sliderText?.trim()) {
      case "Strongly Disgree":
        activeSlider = 1;
        break;
      case "Strongly<br/>Disgree":
        activeSlider = 1;
        break;
      case "Disagree":
        activeSlider = 2;
        break;
      case "Neutral":
        activeSlider = progress;
        break;
      case "Agree":
        activeSlider = 4;
        break;
      case "Strongly Agree":
        activeSlider = 5;
        break;
      case "Strongly<br/>Agree":
        activeSlider = 5;
        break;
      default:
        activeSlider = progress;
    }
    return activeSlider;
  }

  const updateQuestion = (event, step) => {
    // props.question.answerTxt = event.target.value;
    setTextAns(event.target.value);
    // setState({answerTxt: event.target.value});
    props.updateTextAnswer(props.question?.id, event.target.value);
    // return true;
  }

  const updateMonthYear = (month, year) => {
    if (month.number) setMonth(month);
    if (year) setYear(year);
    if (month.number && year) {
      let monthYear = year + "-" + month.number;
      // props.updateTextAnswer(props.question?.id, monthYear);
      props.updateTextAnswerAndMoveToNextQuestion(props.question?.id, monthYear, -1, true);
    }
    // if (month == "00" && year == "0000") {
    //   let monthYear = year + "-" + month;
    //   props.updateTextAnswer(props.question?.id, monthYear);
    // }
  }

  const handleMultipleAnswer = (ansval, anstext) => {
    // Set the selected answer immediately for visual feedback
    setSelectedAnswers(anstext);

    // Call the parent function to handle the answer
    props.questionAnswered(ansval);

    // Remove the setTimeout that was causing timing issues
    // The visual feedback should now be handled by the question's answer state
  };

  function isThisOptionSelected(selectedAnswers, ans) {
    // Primary check: use the question's answer state
    if (props.question.answer > 0 && ans.value === props.question.answer) {
      return true;
    }

    // Fallback check: use selectedAnswers for immediate visual feedback
    if (selectedAnswers === ans.desktopText) {
      return true;
    }

    return false;
  }

  function removeOptionSelectedInPrevQuestion(ans) {
    const variables = props.results.variables;

    if (props.question?.pageId == 953) {
      const mostScores = [
        { score: 1, value: variables?.find((el) => el.variable == "heart_round1_m")?.score || 0 },
        { score: 2, value: variables?.find((el) => el.variable == "soul_round1_m")?.score || 0 },
        { score: 3, value: variables?.find((el) => el.variable == "mind_round1_m")?.score || 0 },
        { score: 4, value: variables?.find((el) => el.variable == "str_round1_m")?.score || 0 },
      ];

      const leastScores = [
        { score: 1, value: variables?.find((el) => el.variable == "heart_round1_l")?.score || 0 },
        { score: 2, value: variables?.find((el) => el.variable == "soul_round1_l")?.score || 0 },
        { score: 3, value: variables?.find((el) => el.variable == "mind_round1_l")?.score || 0 },
        { score: 4, value: variables?.find((el) => el.variable == "str_round1_l")?.score || 0 },
      ];

      const maxScoreObj = mostScores.reduce((max, obj) => (obj.value > max.value ? obj : max), { name: null, value: -Infinity });
      const maxLeastScoreObj = leastScores.reduce((max, obj) => (obj.value > max.value ? obj : max), { name: null, value: -Infinity });

      // console.log("maxScoreObj:", maxScoreObj);
      // console.log("maxLeastScoreObj:", maxLeastScoreObj);
      // console.log("max-Ans:", props.question.answers);

      if (ans.value == maxScoreObj.score || ans.value == maxLeastScoreObj.score) return true;
    }
    else if (props.question?.pageId == 954) {
      const mostScores = [
        { score: 1, value: variables?.find((el) => el.variable == "per_round1_m")?.score || 0 },
        { score: 2, value: variables?.find((el) => el.variable == "strat_round1_m")?.score || 0 },
        { score: 3, value: variables?.find((el) => el.variable == "vis_round1_m")?.score || 0 },
        { score: 4, value: variables?.find((el) => el.variable == "col_round1_m")?.score || 0 },
      ];

      const leastScores = [
        { score: 1, value: variables?.find((el) => el.variable == "per_round1_l")?.score || 0 },
        { score: 2, value: variables?.find((el) => el.variable == "strat_round1_l")?.score || 0 },
        { score: 3, value: variables?.find((el) => el.variable == "vis_round1_l")?.score || 0 },
        { score: 4, value: variables?.find((el) => el.variable == "col_round1_l")?.score || 0 },
      ];

      const maxScoreObj = mostScores.reduce((max, obj) => (obj.value > max.value ? obj : max), { name: null, value: -Infinity });
      const maxLeastScoreObj = leastScores.reduce((max, obj) => (obj.value > max.value ? obj : max), { name: null, value: -Infinity });

      // console.log("maxScoreObj:", maxScoreObj);
      // console.log("maxLeastScoreObj:", maxLeastScoreObj);
      // console.log("max mostScores:", mostScores);
      // console.log("max leastScores:", leastScores);
      // console.log("max-Ans:", props.question.answers);

      if (ans.value == maxScoreObj.score || ans.value == maxLeastScoreObj.score) return true;
    }
    else if (props.question?.pageId == 866 || props.question?.pageId == 947) {
      let currentQVar = props.question?.variable;
      if (currentQVar?.includes('pass2') && (props.question?.pageId == 866 || props.question?.pageId == 947)) {
        let searchVar = currentQVar.replace("pass2", "pass1");
        const searchQ = props?.questions?.find((el) => el?.variable == searchVar);
        // console.log("searchQ-props?.questions",searchQ,props?.questions)
        if (searchQ?.answer == ans.value) return true
      }
    }

    return false;
  }



  const modifyString = (input) => {
    const match = input.match(/(\d+)/);
    if (match) {
      const number = parseInt(match[0], 10);
      const modifiedNumber = number - 10;
      return input.replace(match[0], modifiedNumber.toString());
    }
    return input;
  };

  // Example usage
  const input = "st11_self_pass2";
  const result = modifyString(input);
  // console.log(result); // Output: "st1_self_pass2"


  const giveHeaderColor = (data) => {
    if (data?.question.includes("LEAST")) setSelectionColor("red");
    else if (data?.question.includes("MOST")) setSelectionColor("green");
    else setSelectionColor("green")
  }

  // console.log(selectedAnswers)
  const givePlaceholder = (queId) => {
    if (queId == 1250) {
      return "We’d love to hear how God might have blessed you.";
    } else if (queId == 1251) {
      return "We strive to serve our King with the best! Any ideas on what we can improve?";

    } else {
      return "Please type your response here";
    }
  }

  // const setQuestionColor = (question) => {
  //   if (selectionColor === "red") {
  //     question = question?.replace(">LEAST", " style='color: #B6111F; font-weight:800'>LEAST");
  //   } else {
  //     question = question?.replace(">MOST", " style='color: #3FA554; font-weight:800'>MOST");
  //   }
  //   // console.log(question);
  //   return question;
  // }
  // const setQuestionColor = (question) => {
  //   // console.log("questionhrhrugu" , question)
  //   if (selectionColor === "red") {
  //     question = question?.replace("LEAST", "<span style='color: #B6111F;font-weight: 400;'> LEAST </span>") ;
  //   } else {
  //     question = question?.replace("MOST", "<span style='color: #00577D; font-weight: 400;'> MOST </span>");
  //   }
  //   return question;
  // }

  const setQuestionColor = (question) => {
    // Remove the existing dot
    question = question?.replace(/\s*\.\s*$/, '');
    if (props.question?.pageId !== 948) {
      if (selectionColor === "red") {
        question = question?.replace("LEAST", "<span style='color: #B6111F;font-weight: 400;'> LEAST </span>");
        // question = question?.replace("SECOND", "<span style='color: #B6111F;font-weight: 400;'> SECOND </span>");
        question = question?.replace("SECOND", "");

      } else {
        question = question?.replace("MOST", "<span style='color: #00577D; font-weight: 400;'> MOST </span>");
        // question = question?.replace("SECOND", "<span style='color: #00577D; font-weight: 400;'> SECOND </span>");
        question = question?.replace("SECOND", "");

      }
    }
    return question;
  }



  const classes = {
    menulist: "month-select"
  }

  const notApplicableQuestions = [1192, 1193, 1196];


  const getColorForSelected = (selectedAnswers, ans) => {
    // console.log("selectedAnswers-ans", selectedAnswers, ans)

    // Use isThisOptionSelected for consistent logic
    if (isThisOptionSelected(selectedAnswers, ans) && selectionColor === 'red') {
      return "selected-red"
    } else if (isThisOptionSelected(selectedAnswers, ans) && selectionColor === 'green') {
      return "selected-green"
    } else {
      return ""
    }
  }
  const getColorForSelectedCurrent = (selectedAnswers, ans) => {
    if (isThisOptionSelected(selectedAnswers, ans) && selectionColor === 'red') {
      return "#B6111F"
    } else if (isThisOptionSelected(selectedAnswers, ans) && selectionColor === 'green') {
      return "#00577D"
    } else {
      return ""
    }
  }

  const showQuestion = () => {
    if (props?.question?.question?.includes("SECOND LEAST")) {
      return true;
    }
    else {
      return true;
    }
  }

  const leader = props.leader
  const member = props.member
  const respondentName = props.respondentName

  // console.log("leader", leader)
  // console.log("member", member)
  // console.log("respondentName", respondentName)

  // useEffect(()=>{
  //   if(searchParams.get("leader")){
  //     setHasLeader(true); 
  //   }
  //   if(searchParams.get("name")){
  //     setName(searchParams.get("name")); 
  //   }
  // },[searchParams])

  // console.log('member', member)
  // console.log('leader', leader)

  useEffect(() => {
    if (leader || member) {
      setHasLeader(true);
      setName(leader);
    } else {
      setHasLeader(false);
    }
  }, [searchParams, member, leader]);

  // console.log("props answertype", props?.question?.answerType)

  function replacePronouns(text, hasLeader, leader, pageId) {
    if (isHideInitials) {
      text = text?.replace(/-?\s*\(\s*[a-zA-Z]+\s*\)/g, ""); // prod-remove: remove initials ( uncomment on prod )
    }

    if (hasLeader) {
      let firstName = leader?.split(" ")[0]?.trim();
      firstName = firstName ? firstName.charAt(0).toUpperCase() + firstName.slice(1) : "";
      const boldName = pageId === 948 ? `<strong>${firstName}</strong>` : firstName;
      const safeFirstName = firstName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      return text
        ?.replace(/\bI\b/g, boldName)
        ?.replace(/\bmy\b/g, boldName + "'s")
        ?.replace(/\bMy\b/g, boldName + "'s")
        ?.replace(/\bme\b/g, boldName)
        ?.replace(/\bam\b/g, "is")
        ?.replace(/\bimmediately start\b/g, "immediately starts")
        ?.replace(/\bour objectives\b/g, "the team’s objectives")
        ?.replace(/\bcome\b/g, "comes")

        ?.replace(/\bhave\b/g, "has")
        ?.replace(/\bbelieve our\b/g, "believes their")

        ?.replace(/\bstruggle\b/g, "struggles")



        ?.replace(/\brely\b/g, "relies")
        ?.replace(/\bbelieve\b/g, "believes")
        ?.replace(/\brespect\b/g, "respects")
        ?.replace(/\breach\b/g, "reaches")
        ?.replace(/\bI reach my goal\b/g, "personal goals are reached")
        ?.replace(/\bshare\b/g, "shares")
        ?.replace(/\bevaluate\b/g, "evaluates")
        ?.replace(/\bmake\b/g, "makes")
        ?.replace(/\bwant\b/g, "wants")
        ?.replace(/\bfind\b/g, "finds")
        // ?.replace(/\bbelong\b/g, "belongs") 
        ?.replace(/\btake\b/g, "takes")
        ?.replace(/\bfollow\b/g, "follows")
        ?.replace(/\bdevelop\b/g, "develops")

        ?.replace(/\bthat develops depth of character\b/g, "that develop depth of character")

        ?.replace(/\bconsider myself\b/g, "considers himself/herself")
        ?.replace(/\baction orientated\b/g, "action-oriented")
        ?.replace(/\baction-orientated\b/g, "action-oriented")
        ?.replace(/\borientated\b/g, "oriented")
        ?.replace(/\bpride myself on\b/g, "takes pride in")
        ?.replace(/\benjoy\b/g, "enjoys")
        ?.replace(/\bensure\b/g, "ensures")
        ?.replace(/\bembrace\b/g, "embraces")
        ?.replace(/\bavoid\b/g, "avoids")
        ?.replace(/\bpersist\b/g, "persists")
        ?.replace(/\bgive\b/g, "gives")
        ?.replace(/\bsee\b/g, "sees")
        ?.replace(/\bdevelops others by helping them sees the “why” behind the work\b/g, "develops others by helping them see the “why” behind the work")
        ?.replace(/\btry\b/g, "tries")
        ?.replace(/\blearn\b/g, "learns")
        ?.replace(/\bis inspired to learns\b/g, "is inspired to learn")
        ?.replace(/\bfind\b/g, "finds")
        ?.replace(/\bwhere we should be heading\b/g, "where the team should be heading")
        ?.replace(/\bessential to create a successful organization\b/g, "essential to creating a successful organization")
        ?.replace(/\bfuture of our organization\b/g, "future of the organization")
        ?.replace(/\beffective strategies for our organization\b/g, "effective strategies for the organization")
        // ?.replace(/\bthey can start\b/g, "starting")

        ?.replace(new RegExp(`\\b${boldName} work with\\b`, 'g'), `they work with`)
        ?.replace(new RegExp(`\\b${boldName} feel a sense\\b`, 'g'), `they feel a sense`)


        ?.replace(new RegExp(`\\b${boldName} need\\b`, 'g'), `${boldName} needs`)
        ?.replace(new RegExp(`\\b${boldName} feel\\b`, 'g'), `${boldName} feels`)
        ?.replace(new RegExp(`\\b${boldName} gain\\b`, 'g'), `${boldName} gains`)
        ?.replace(new RegExp(`\\b${boldName} get\\b`, 'g'), `${boldName} gets`)
        ?.replace(new RegExp(`\\b${boldName} like\\b`, 'g'), `${boldName} likes`)
        ?.replace(new RegExp(`\\b${boldName} gets ${boldName}'s tasks completed\\b`, 'g'), `personal tasks are completed`)
        ?.replace(new RegExp(`\\b${boldName} reaches ${boldName}'s goals\\b`, 'g'), `personal goals are reached`)
        ?.replace(new RegExp(`\\b overwhelm ${boldName}'s good judgment\\b`, 'g'), ` overwhelm good judgement`)
        ?.replace(new RegExp(`\\b push ${boldName}'s team to win\\b`, 'g'), ` push the team to win`)
        ?.replace(new RegExp(`\\b help ${boldName}'s team connect more deeply with each other\\b`, 'g'), ` help the team connect more deeply with each other`)
        ?.replace(new RegExp(`\\b${boldName} shares a proposal, ${boldName} wants to know “who” is with ${boldName}\\b`, 'g'), ` sharing a proposal, ${boldName} wants to know “who” is on board`)
        ?.replace(new RegExp(`\\b${boldName} is surrounded by ${boldName}'s people\\b`, 'g'), `surrounded by ${boldName}'s people`)
        ?.replace(new RegExp(`\\b${boldName} feels like ${boldName} is living out ${boldName}'s\\b`, 'g'), `living out a`)
        ?.replace(new RegExp(`\\b${boldName} comes alive when ${boldName} feels like ${boldName} belong\\b`, 'g'), `${boldName} comes alive when ${boldName} feels a sense of belonging`)
        ?.replace(new RegExp(`\\bbefore ${boldName} \\b`, 'g'), `before they `)
        ?.replace(new RegExp(`\\bguide ${boldName} \\b`, 'g'), `guide them `)
        ?.replace(new RegExp(`\\b${boldName} gains the most satisfaction when ${boldName} reaches ${boldName}'s goals\\b`, 'g'), `${boldName} gains the most satisfaction when personal goals are reached`)
        ?.replace(new RegExp(`\\b when ${boldName} is doing something\\b`, 'g'), ` while doing something`)
        ?.replace(new RegExp(`\\b${boldName} is given measurable goals\\b`, 'g'), ` given measurable goals`)
        ?.replace(new RegExp(`overwhelm ${boldName}'s good judgement`, 'g'), ` overwhelm good judgement`)
        ?.replace(new RegExp(`when ${boldName} shares a proposal, ${boldName} wants to know “who” is with ${boldName}`, 'g'), `when sharing a proposal, ${boldName} wants to know “who” is on board`)
        ?.replace(new RegExp(`\\b${boldName} feels more deeply connected to others\\b`, 'g'), `feeling deeply connected to others`)
        ?.replace(new RegExp(`\\b${boldName} is driving others to deliver results\\b`, 'g'), `driving others to deliver results`)
        ?.replace(new RegExp(`\\b${boldName}'s team to win \\b`, 'g'), `the team to win`)
        ?.replace(new RegExp(`\\b${boldName}'s team connects more deeply with each other \\b`, 'g'), `the team connect more deeply with each other`)
        ?.replace(new RegExp(`\\b${boldName} needs to understand the processes before they can start\\b`, 'g'), `${boldName} needs to understand the processes before starting`)
        ?.replace(new RegExp(`\\b${boldName} can usually sees\\b`, 'g'), `${boldName} can usually see`)
        ?.replace(new RegExp(`\\b${boldName} ensures ${boldName}'s decisions \\b`, 'g'), `${boldName} ensures their decisions  `)
        ?.replace(new RegExp(`\\b${boldName} is always searching for the reasons "why" ${boldName} is doing something\\b`, 'g'), `${boldName} is always searching for the reasons "why" they are doing something  `)
        ?.replace(new RegExp(`based on the policies that guide ${boldName}`, 'g'), `based on the policies that guide them`)
        ?.replace(new RegExp(`surrounded by ${boldName}'s people`, 'g'), `surrounded by their people`)
        ?.replace(new RegExp(`comes alive when ${boldName} feels`, 'g'), `comes alive when they feel `)
        ?.replace(new RegExp(`relies heavily on ${boldName}'s drive`, 'g'), `relies heavily on their drive `)
        ?.replace(new RegExp(`relies heavily on the meaning of ${boldName}'s story`, 'g'), `relies heavily on the meaning of their story `)
        ?.replace(new RegExp(`to function well in ${boldName}'s work`, 'g'), ` to function well in their work`)
        ?.replace(new RegExp(`“why” ${boldName} is doing something\\b`, 'g'), `“why” they are doing something`)
        ?.replace(new RegExp(`is at ${boldName}'s best when\\b`, 'g'), `is at their best when `)
        ?.replace(new RegExp(`is a very high value of ${boldName}'s leadership\\b`, 'g'), `is a very high value of their leadership`)
        ?.replace(new RegExp(`When ${boldName} shares a proposal, ${boldName} wants to know "who" is with ${boldName}\\b`, 'g'), `When sharing a proposal, ${boldName} wants to know “who” is on board`)
    }
    return text;
  }

  // console.log("props?.question?.question", props?.question?.question)

  // console.log("QUESTION", props.question?.question);
  // console.log("REPLACED", (props.question?.question).replace(hasLeader ? leader : "you"));

  // console.log("hasLeader:", hasLeader);
  // console.log("leader:", leader);

  return (
    showQuestion() ?
      <div>
        {/* <div className="question" style={{ minHeight: props?.question?.answerType === "radio" ? "140px" : windowWidth > 650 ? "110px" : "50px" }}>
          <p style={{ maxWidth: "65ch", fontSize:"32px", fontWeight:"400", lineHeight:"48px", letterSpacing:"-0.011em", textAlign:"center" }} dangerouslySetInnerHTML={{__html: setQuestionColor(props.question?.question)}}></p>
        </div> */}
        {props.question?.answerType === "slider" && (
          <p className='heading-p'>Select the response {`${props.question?.pageId == 948 ? "that" : "which"}`} most often {windowWidth < 650 ? <><br />represents </> : " represents "} {hasLeader ? (<span style={{ textTransform: 'capitalize', fontWeight: '700' }}>{leader + "."}</span>) : ("you.")}</p>)}
        <p style={{
          maxWidth: "65ch",
          fontSize: window.innerWidth > 650 ? "32px" : "18px",
          fontWeight: "400",
          lineHeight: window.innerWidth > 650 ? "48px" : "26px",
          letterSpacing: "-0.011em",
          textAlign: "center",
          marginBottom: window.innerWidth < 650 && 0,
          color: props.question?.answerType === "slider" ? "#00577D" : window.innerWidth > 650 ? "#1E1E1E" : "#343333",
        }}
          dangerouslySetInnerHTML={{
            __html: (() => {
              // Get the question text or empty string if undefined
              let questionText = props.question?.question || '';

              // Apply all text transformations
              questionText = questionText
                .replace("you.", hasLeader ? `<span class="leader-name">${leader}</span>.` : "you.")
                .replace(/\brepresents\.?$/, hasLeader ? `represents <span class="leader-name">${leader}</span>.` : "represents you.")
                .replace("MOST", `<span class="most">MOST</span>`)
                .replace("LEAST", `<span class="least">LEAST</span>`);
              let formattedText = setQuestionColor(replacePronouns(questionText, hasLeader, leader, props.question?.pageId || ""));
              formattedText = formattedText.replace(/[.!?]+\s*$/, '');
              return formattedText + '.';
            })(),
          }}
        >
        </p>
        {windowWidth < 650 && <div style={{ height: "20px" }}></div>}
        {
          (() => {
            // console.log('answerType',props.question?.answerType)
            switch (props.question?.answerType) {
              case "textarea":
                return <>
                  <div className="textarea-field">
                    {/* <TextField hiddenLabel multiline rows={windowWidth > 650 ? 4 : 6} placeholder="Please type your response here" value={props.question?.answerTxt} onChange={(e) => {updateQuestion(e, 1)}} fullWidth variant="standard" size="normal" InputProps={{ disableUnderline: true }} className="form-details-text" /> */}
                    {/* <TextField hiddenLabel multiline rows={windowWidth > 650 ? 4 : 6} placeholder={givePlaceholder(props?.question?.id)} value={textAns} onChange={(e) => {updateQuestion(e, 1)}} fullWidth variant="standard" size="normal" InputProps={{ disableUnderline: true }} className="form-details-text" /> */}
                    {/* TextareaAutosize is throwing errors on resize and its a known issue so have used textarea for now */}
                    {/* <TextareaAutosize minRows={windowWidth > 650 ? 4 : 6} maxRows={6}
                    placeholder={givePlaceholder(props?.question?.id)} value={textAns}
                    onChange={(e) => updateQuestion(e, 1)} 
                    className={`form-details-text textarea-autosize ${textAns?.length > 0 ? "text-content" : "text-placeholder"}`} 
                    /> */}

                    <textarea rows={windowWidth > 650 ? 4 : 6} placeholder={givePlaceholder(props?.question?.id)}
                      value={textAns} onChange={(e) => updateQuestion(e, 1)}
                      className={`form-details-text textarea-autosize ${textAns?.length > 0 ? "text-content" : "text-placeholder"}`}
                      style={{ width: '100%' }} />

                  </div>
                </>

              case "radio":
                return <>
                  <div className="radio-container">
                    <div className="slider-labels" style={getRadioWidth(props.question?.answers?.length)}>
                      {
                        props.question?.answers?.map((data, index) => (
                          // were using checkSelected(data.value) here before this change to orderNo
                          <div className={checkSelected(data.orderNo)} key={`labels-${index}`} style={{ left: getLeftRadio(index) + '%', width: radioOptionWidth(props?.question?.answers?.length), display: "flex", cursor: "pointer" }} onClick={() => {
                            // console.log("data.value", data.value);
                            updateRadioStep(data.value, data.orderNo);
                          }}>
                            {/* <div className={checkSelected(data, data.value)} key={`labels-${index}`} style={{ left: getLeft(index) + '%'}} onClick={() => updateStep(data.value)}> */}
                            {/* <FormControlLabel value={data.value} control={<Radio />} label="" /> */}
                            <Radio checked={data.value === progress} value={progress} sx={{ '&, &.Mui-checked': { color: '#343333', }, }} />
                            <p className="desktop" style={getLabelStyle()}>{data.desktopText}</p>
                            <p className="mobile" style={getLabelStyle()}>{data.desktopText}</p>
                          </div>
                        ))
                      }
                      {/* { 
                            props.question?.answers.map((data, index) => (
                              <FormControlLabel value={data.value} control={<Radio />} label={data.value} onClick={() => updateStep(data.value)} />
                              // <a className="point" key={`points-${index}`} style={{ left: getLeft(index) + '%', opacity: checkOpacity(index) }}></a>
                            ))
                          } */}

                    </div>
                  </div>
                </>
              // else return <div key={idx} style={{ backgroundColor: isThisOptionSelected(selectedAnswers, ans) && selectionColor === 'red' ? '#FFDADA' : '' }} className={`answer ${isThisOptionSelected(selectedAnswers, ans) ? "selected" : ""}`} onClick={() => handleMultipleAnswer(ans.value, ans.desktopText)}>


              case "multiple_choice":
                return <>
                  <div className="multiple-choice-container" >
                    <div className="multiple-choice">
                      {/* TODO: add multiple choice type options */}
                      {props.question?.answers?.map((ans, idx) => {
                        // console.log("ans", ans)
                        if (removeOptionSelectedInPrevQuestion(ans)) return null;
                        else return <div key={idx} className={`answer ${getColorForSelected(selectedAnswers, ans)}`} onClick={() => handleMultipleAnswer(ans.value, ans.desktopText)}>
                          {/* {isThisOptionSelected(selectedAnswers, ans) ? <CheckCircleRounded className="tick-icon" style={{ color: isThisOptionSelected(selectedAnswers, ans) && selectionColor === 'red' ? '#3FA554' : '' }} /> : <img src={unchecked} style={{width:'20px', marginRight:'12px'}}/>} */}
                          {ans.value == props.question.answer ? <CheckCircleRounded className="tick-icon" style={{ color: isThisOptionSelected(selectedAnswers, ans) && selectionColor === 'red' ? '#3FA554' : '' }} /> : <img src={unchecked} style={{ width: '20px', marginRight: '12px' }} />}
                          <span className="answer-text">  {replacePronouns(ans.desktopText, hasLeader, leader)}</span>
                        </div>
                      })}

                      {/* Added conditional render to get the hover background according to the keyword */}
                      {/* {props.question?.answers?.map((ans, idx) => (
                        selectionColor === "red" ? (<div key={idx} style={{ backgroundColor: getColorForSelectedCurrent(selectedAnswers, ans), color: isThisOptionSelected(selectedAnswers, ans) ? '#FFFFFF' : "#5F5F5F" }} className={`least answer ${ (selectedAnswers, ans)}`} onClick={() => handleMultipleAnswer(ans.value, ans.desktopText)} >
                                {isThisOptionSelected(selectedAnswers, ans) ? (
                                  <CheckCircleRounded className="tick-icon"/>
                                ) : (
                                  <CircleIcon className="tick-icon" style={{ color: "#E1E5EB" }} />
                                )}
                                <span className="answer-text" dangerouslySetInnerHTML={{__html : ans.desktopText}} ></span>
                            </div>
                        ) : (<div key={idx} style={{ backgroundColor: getColorForSelectedCurrent(selectedAnswers, ans), color: isThisOptionSelected(selectedAnswers, ans) ? '#FFFFFF' : "#5F5F5F" }} className={`most answer ${getColorForSelected(selectedAnswers, ans)}`} onClick={() => handleMultipleAnswer(ans.value, ans.desktopText)} >
                          {isThisOptionSelected(selectedAnswers, ans) ? (
                              <CheckCircleRounded className="tick-icon" />
                          ) : (
                              <CircleIcon className="tick-icon" style={{ color: "#E1E5EB" }} />
                          )}
                          <span className="answer-text">{ans.desktopText}</span>
                      </div>)
                    ))} */}

                    </div>
                  </div>
                  {notApplicableQuestions.includes(props.question?.id) ?
                    <div className="not-applicable-container">
                      <SkipQuestionCheckbox key={props.question?.id} skipQuestionFunction={props.questionAnswered} question={props.question} setSelectedAnswers={setSelectedAnswers} />
                    </div>
                    : null
                  }
                </>

              case "month_year":
                return <div className="month-year-container">
                  <div className="month-year-select-container">
                    <div className="month-container">
                      <p className="month-header">Month</p>
                      <Select id="month-select" className={`month-select ${!notApplicable ? 'border-selected' : ''}`} disabled={props.question?.answer == 0 ? true : false}
                        displayEmpty renderValue={(value) => (value !== undefined ? value : "January")}
                        IconComponent={(props) => (<ExpandMore {...props} />)}
                        MenuProps={{ classes: { paper: classes.menulist } }}
                        value={month.name} onChange={(e) => updateMonthYear(months.find((m) => m.name === e.target.value), year)}
                      >
                        {months?.map((el, idx) => {
                          return <MenuItem key={idx} value={el?.name}>{el?.name}</MenuItem>
                        })}
                      </Select>
                    </div>
                    <div className="year-container">
                      <p className="year-header">Year</p>
                      <Select id="year-select" className={`month-select year-select ${!notApplicable ? 'border-selected' : ''}`}
                        disabled={props.question?.answer == 0 ? true : false}
                        displayEmpty renderValue={(value) => (value !== "" ? value : "2015")}
                        IconComponent={(props) => (<ExpandMore {...props} />)}
                        MenuProps={{ classes: { paper: classes.menulist } }}
                        value={year} onChange={(e) => updateMonthYear(month, e.target.value)}
                      >
                        {years?.map((el, idx) => {
                          return <MenuItem key={idx} value={el?.year}>{el?.year}</MenuItem>
                        })}
                      </Select>
                    </div>
                  </div>

                  {notApplicableQuestions.includes(props.question?.id) ?
                    <div className="not-applicable-container">
                      <SkipQuestionCheckbox key={props.question?.id} skipQuestionFunction={props.questionAnswered} question={props.question} setSelectedAnswers={setSelectedAnswers} updateMonthYear={updateMonthYear} updateTextAnswerAndMoveToNextQuestion={props.updateTextAnswerAndMoveToNextQuestion} setYear={setYear} setMonth={setMonth} />
                    </div>
                    : null
                  }
                </div>

              case "select":

                const dropDownOptions = props.question?.answers?.map((ans, index) => {
                  return ({ ...ans, value: ans.desktopText, label: ans.desktopText })
                })

                return (
                  <div className="select-container">
                    <Select id="select" className={`select ${progress === 0 ? '' : 'border-selected'}`} label="Select" value={progress} IconComponent={(props) => (<ExpandMore {...props} />)}
                      MenuProps={{ classes: { paper: classes.menulist } }}
                      onChange={(e) => updateDropDownStep(e.target.value, props.question.orderNo)} >
                      <MenuItem value={0}>Select</MenuItem>
                      {props.question?.answers?.map((data, index) => {
                        return <MenuItem key={index} value={data.value}>{data.desktopText}</MenuItem>
                      })}
                    </Select>

                    {/* <ReactSelect classNamePrefix="react-select" className="form-details-text react-select"
                      options={dropDownOptions} // options={props.question?.answers}
                      onChange={(e) => updateDropDownStep(e.orderNo, props.question.orderNo)}
                      value={props.question.answer}
                      theme={(theme) => ({
                      ...theme,
                      colors: { ...theme.colors,
                        primary25: '#F3F3F3', // Selected option background color
                        primary50: '#fff', // on click option color
                        primary: '#3B3A3A',
                        neutral0: '#F4F4F4',
                        neutral50: '#A5A5A5', // Placeholder text color
                      }, cursor: "pointer",
                    })} placeholder={"Select"} /> */}
                  </div>
                );

              default:
                return (
                  //  <div className="slider-container" style={{ width: sliderWidth + '%' }}>
                  //   <div className="slider">
                  //     {showSlider ? <Slider key={props.question?.id}
                  //       valueLabelDisplay="off"
                  //       step={1} min={1} max={maxWidth}
                  //       value={progress}
                  //       // value={updateSliderTextHighlight(progress)}
                  //       className="custom-slider"
                  //     /> : <div className="slider-none-adjust"></div>}
                  //     <div className="slider-points">
                  //       {
                  //         props.question?.answers?.map((data, index) => (
                  //           <a className="point" key={`points-${index}`} style={{ left: getLeft(index) + '%', opacity: checkOpacity(index) }} onClick={() => updateStep(data.value, data.orderNo)}></a>
                  //         ))
                  //       }
                  //     </div>
                  //     <LinearProgress className="custom-bar" variant="determinate" value={0} />

                  //   </div>
                  //   <div className="slider-labels">
                  //     {
                  //       props.question?.answers?.map((data, index) => {
                  //         return (
                  //           // were using checkSelected(data.value) here before this change to orderNo
                  //           <div className={checkSelected(data.orderNo)} key={`labels-${index}`} style={{ left: getLeft(index) + '%' }} onClick={() => updateStep(data.value, data.orderNo)}>
                  //             {/* <p className="desktop" style={getLabelStyle()}>{data.desktopText}</p> */}
                  //             <p className="desktop" style={getLabelStyle()} dangerouslySetInnerHTML={{ __html: data.desktopText }} />
                  //             {/* <p className="mobile" style={getLabelStyle()}>{data.mobileText}</p> */}
                  //             <p className="mobile" style={getLabelStyle()} dangerouslySetInnerHTML={{ __html: data.mobileText }} />
                  //           </div>
                  //         );
                  //       })}
                  //   </div>
                  // </div>
                  <div className="slider-container" style={{ width: sliderWidth + '%' }}>
                    <div className="slider-buttons">
                      {
                        props.question?.answers?.map((data, index) => {
                          return (
                            // were using checkSelected(data.value) here before this change to orderNo
                            <div className='containers'>
                              <div key={`labels-${index}`} className='slider-btns' >
                                {/* <p className="desktop" style={getLabelStyle()}>{data.desktopText}</p> */}
                                <p className={checkSelectedlabel(data.orderNo)} dangerouslySetInnerHTML={{ __html: data.desktopText }} onClick={() => updateStep(data.value, data.orderNo)} />
                                {/* <p className="mobile" style={getLabelStyle()}>{data.mobileText}</p> */}
                                <p className="mobile" style={getLabelStyle()} dangerouslySetInnerHTML={{ __html: data.mobileText }} />
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                )
            }
          }).call(this)
        }

        {/* <div className="slider-container" style={{ width: state.sliderWidth + '%' }}>
          <div className="slider">
            { state.showSlider ? <Slider
              key={props.question.id}
              valueLabelDisplay="off"
              step={1}
              min={1}
              max={state.maxWidth}
              value={state.progress}
              className="custom-slider"
            /> : <div className="slider-none-adjust"></div> }
            <div className="slider-points">
            {/* { !state.showSlider ? 
              <a className="point" style={{ left: '0%'}} onClick={() => updateStep(1)}></a> : null } */}
        {/* { 
                props.question?.answers.map((data, index) => (
                  <a className="point" key={`points-${index}`} style={{ left: getLeft(index) + '%', opacity: checkOpacity(index) }} onClick={() => updateStep(data.value)}></a>
                ))
              }
            </div>
            <LinearProgress className="custom-bar" variant="determinate" value={0} />
            
          </div>
          <div className="slider-labels">
            { 
              props.question?.answers.map((data, index) => (
                <div className={checkSelected(data, data.value)} key={`labels-${index}`} style={{ left: getLeft(index) + '%'}} onClick={() => updateStep(data.value)}>
                  <p className="desktop" style={getLabelStyle()} dangerouslySetInnerHTML={{__html: data.desktopText }}></p>
                  <p className="mobile" style={getLabelStyle()} dangerouslySetInnerHTML={{__html: data.mobileText }}></p>
                </div>
              ))
            }
          </div>
        </div> */}

      </div>
      :
      <></>
  );
}

export default Question;



const SkipQuestionCheckbox = (props) => {

  const [notApplicable, setNotApplicable] = useState(false);

  useEffect(() => {
    if (props.question?.answer == 0) {
      setNotApplicable(true);
    }
  }, [props.question?.answer]);

  const notApplicableChecked = () => {
    const answerType = props.question.answerType;
    if (props.question.answerType == "slider") {
      // props.skipQuestionFunction(0);
    }

    if (answerType == "month_year") {
      // props.updateMonthYear("00", "0000");
      props.updateTextAnswerAndMoveToNextQuestion(props.question?.id, "0000-00", 0, true);
    }

    if (answerType == "multiple_choice") {
      props.skipQuestionFunction(0);
      props.setSelectedAnswers("");
    }
  }

  const notApplicableUnchecked = () => {
    const answerType = props.question.answerType;
    if (answerType == "slider") {
      // props.skipQuestionFunction(0);
    }

    if (answerType == "month_year") {
      // props.updateMonthYear({ name: "January", number: "01" }, 1995);
      props.updateTextAnswerAndMoveToNextQuestion(props.question?.id, undefined, undefined, false);
      props.setYear("");
      props.setMonth("");
    }

    if (answerType == "multiple_choice") {
      props.skipQuestionFunction(undefined);
      props.setSelectedAnswers("");
    }
  }

  return (
    <FormControlLabel control={
      <Checkbox checked={notApplicable}
        onChange={(e) => {
          setNotApplicable(e.target.checked);
          if (e.target.checked) {
            notApplicableChecked();
          } else {
            notApplicableUnchecked();
          }
        }}
        sx={{
          color: "#343333",
          '&.Mui-checked': { color: "#EF8933", },
        }}
      />
    } label="Not applicable" style={{ cursor: "pointer" }}
      className='not-applicable'
    />
  );

}

